import React, { useState } from "react";
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { Modal } from 'antd';
import { faArrowRightLong, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from 'react-bootstrap/Card';
const localizer = momentLocalizer(moment);

const Announcements = () => {

    const events = [
        {
            title: 'Event 1',
            start: new Date(2024, 2, 14, 10, 0),
            end: new Date(2024, 2, 14, 12, 0),
        },
        {
            title: 'Event 2',
            start: new Date(2024, 2, 15, 13, 0),
            end: new Date(2024, 2, 15, 15, 0),
        },
        // Add more events as needed
    ];
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const handleSelectEvent = (event) => {
        setSelectedEvent(event);
        setModalVisible(true);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
    };
    const data = [
        {
            title: "AGM Meeting 2024 ",
            date: "27th Feb 09:30",
            participants: "10 Participants"
        },
        {
            title: "AGM Meeting 2024 ",
            date: "27th Feb 09:30",
            participants: "8 Participants"
        },
        {
            title: "AGM Meeting 2024 ",
            date: "27th Feb 09:30",
            participants: "8 Participants"

        }

    ]

    return (
        <>

            <PageHeader tabs={[{name:"Announcements",route:"/Announcements"},{name:"Proceeding",route:"/Proceeding"}]} heading="AGM/EOGM Announcements" />
            <div className="content_wrap">
                <div className="e_service">
                    <div className='container'>

                        <Calendar
                            localizer={localizer}
                            events={events}
                            onSelectEvent={handleSelectEvent}

                            startAccessor="start"
                            endAccessor="end"
                            style={{ height: 500, marginBottom: "3em" }}
                        />

                    </div>
                    <Modal
                        title={selectedEvent ? selectedEvent.title : ''}
                        open={modalVisible}
                        onCancel={handleCloseModal}
                        footer={null}
                    >
                        {selectedEvent && (
                            <div>
                                <p>Start: {moment(selectedEvent.start).format('LLL')}</p>
                                <p>End: {moment(selectedEvent.end).format('LLL')}</p>
                            </div>
                        )}
                    </Modal>



                </div>
            </div >
        </>
    );
};

export default Announcements;
